import { createContext, useContext } from "react";
import type { IDropdownControlProps } from "./aria";
import type { DropdownContextValue } from "./types";

const DropdownContext = createContext<DropdownContextValue | undefined>(
  undefined,
);

export const DropdownProvider = DropdownContext.Provider;

export const useDropdownContext = (): DropdownContextValue => {
  const context = useContext(DropdownContext);
  if (!context) {
    throw new Error(
      "useDropdownContext must be used within a DropdownProvider",
    );
  }
  return context;
};

/**
 * Widget props for a trigger that renders its own focusable control: role,
 * tabIndex, id, keyboard handler and every `aria-*`. Spread them on that
 * control, and set `innerControl` on the Dropdown so they are not left on the
 * trigger box as well.
 */
export const useDropdownControlProps = (): IDropdownControlProps => {
  return useDropdownContext().controlProps;
};
